const MakeAClaimButton = {
  label: "Make a claim"
};

export default MakeAClaimButton;
